var map = {
	"./add-protocol.svg": "6b62",
	"./delete.svg": "93be",
	"./display.svg": "0b8c",
	"./download.svg": "2621",
	"./edit-session-list.svg": "e98f",
	"./export-to-doc.svg": "0551",
	"./settings.svg": "96f0",
	"./timer.svg": "addc",
	"./tooltip.svg": "dcea",
	"./wallet.svg": "e250"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b383";